export enum CurateListListType {
  Filtered = 'filtered',
  Rotating = 'rotating',
}
